import { useCallback, useEffect, useRef, useState } from "react";
import { Toast } from "../../components/ui/Toast";

/** The prototype's `toast()`: one light note at the bottom of the screen for about three seconds. */
export function useToast() {
  const [note, setNote] = useState<{ message: string; done: boolean; on: boolean }>({ message: "", done: true, on: false });
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => () => clearTimeout(timer.current), []);

  const toast = useCallback((message: string, done = true) => {
    clearTimeout(timer.current);
    setNote({ message, done, on: true });
    timer.current = setTimeout(() => setNote((n) => ({ ...n, on: false })), 2900);
  }, []);

  return { toast, toastNode: <Toast message={note.message} on={note.on} done={note.done} /> };
}
